import * as React from "react";
import type { SVGProps } from "react";
const SvgFavourite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4.8 3.4a1 1 0 0 1 1-1h12.4a1 1 0 0 1 1 1v17.133a.5.5 0 0 1-.82.384L12 15.6l-6.38 5.317a.5.5 0 0 1-.82-.385z"
    />
  </svg>
);
export default SvgFavourite;
